export const ETLIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 64"
    width="25"
    height="25">
    <text
      x="10"
      y="40"
      fontSize="25"
      fontFamily="Arial, sans-serif"
      fill="black">
      ETL
    </text>
  </svg>
);
